import { render } from "./WineryUploadPage.vue?vue&type=template&id=2c83f65d"
import script from "./WineryUploadPage.vue?vue&type=script&lang=js"
export * from "./WineryUploadPage.vue?vue&type=script&lang=js"
script.render = render

export default script